import { RegisteredItemProductPaymentMethod } from '../../models/registered-item/registered-item-product-payment-method.interface';

export const mockRegisteredItemProductPaymentMethod: RegisteredItemProductPaymentMethod =
  {
    type: 'recurringCard',
  };
